/**
 * Deterministic encounter selection: same seed key + pool length → same index.
 * Delimiters in keys are chosen to reduce accidental concatenation collisions.
 */

const ENCOUNTER_SEED_PART_SEP = "\u001e";

export function hashToUint32(input: string): number {
	let h = 0x811c9dc5;
	for (let i = 0; i < input.length; i++) {
		h ^= input.charCodeAt(i);
		h = Math.imul(h, 0x01000193);
	}
	return h >>> 0;
}

export function pickIndexDeterministic(
	seedKey: string,
	length: number,
): number {
	if (length <= 0) {
		throw new Error("pickIndexDeterministic: length must be positive");
	}
	const h = hashToUint32(seedKey);
	return h % length;
}

export interface EncounterSeedKeyParams {
	organizationId: string;
	moduleId: string;
	userId: string;
	stopId: string;
	attemptNumber: number;
	kind: "battle" | "scenario";
}

export function buildEncounterSeedKey(params: EncounterSeedKeyParams): string {
	return [
		params.kind,
		params.organizationId,
		params.moduleId,
		params.userId,
		params.stopId,
		String(params.attemptNumber),
	].join(ENCOUNTER_SEED_PART_SEP);
}
